module.exports = __webpack_public_path__ + "chevron-left-solid-8e9ab83a313435ff9a75.svg";